import { Component, Input } from "@angular/core";
import { RecipientData } from "../../../core/interfaces/recipient-data";

@Component({
  selector: "app-barcode-cell-template",
  templateUrl: "./barcode-cell-template.component.html",
  styleUrls: ["./barcode-cell-template.component.scss"]
})
export class BarcodeCellTemplateComponent {

  @Input() flow: RecipientData | null = null;

checkFlowType(flow: any): boolean {
  const name = flow?.FlowSendTypeConfigurationSendTypeName?.toLowerCase() ?? '';

  if (name.startsWith('raccomandata digitale')) {
    return true; // valido, non va al template
  }

  if (name.startsWith('raccomandata') || name.startsWith('atto')) {
    return false; // non valido, va al template
  }

  return true; // tutti gli altri casi
}

}
